import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CsIconModule } from '@components/icon';

@Component({
  selector: 'processing-banner',
  imports: [
    CommonModule,
    CsIconModule
  ],
  templateUrl: './processing-banner.component.html',
})
export class ProcessingBannerComponent {

}
